// Bank Transfer Payment Module for HobiBaca
import axios from 'axios';

/**
 * Validates the selected bank.
 * @param {string} bank
 * @returns {string|null} error message or null if valid
 */
export function validateBankSelection(bank) {
  if (!bank) return 'Pilih bank terlebih dahulu';
  return null;
}

/**
 * Sends a bank transfer payment request to the backend.
 * @param {string} selectedBank - e.g. 'bca', 'bni', 'bri', 'mandiri', 'permata', 'cimb'
 * @param {string} apiBaseUrl
 * @param {string} jwtToken
 * @returns {Promise<Object>} backend response
 */
export async function sendBankTransferPayment(selectedBank, apiBaseUrl, jwtToken) {
  const paymentData = {
    plan_id: 1,
    payment_gateway: 'midtrans',
    payment_method: 'bank_transfer',
    bank: selectedBank
  };
  const res = await axios.post(
    `${apiBaseUrl}/api/subscriptions/create/`,
    paymentData,
    {
      headers: {
        'Authorization': `Bearer ${jwtToken}`,
        'Content-Type': 'application/json'
      }
    }
  );
  return res.data;
}

/**
 * Extracts VA number and expiry time from the backend response.
 * @param {Object} response
 * @returns {Object} { vaNumber, bank, expiryTime }
 */
export function extractVaInfo(response) {
  let vaNumber = null;
  let bank = null;
  let expiryTime = null;

  if (response.va_numbers && Array.isArray(response.va_numbers) && response.va_numbers.length > 0) {
    vaNumber = response.va_numbers[0].va_number;
    bank = response.va_numbers[0].bank;
  } else if (response.permata_va_number) {
    vaNumber = response.permata_va_number;
    bank = 'permata';
  } else if (response.bill_key && response.biller_code) {
    vaNumber = `${response.bill_key} (bill code: ${response.biller_code})`;
    bank = 'mandiri';
  }
  if (response.expiry_time) {
    expiryTime = response.expiry_time;
  }
  return { vaNumber, bank, expiryTime };
}